export default __webpack_public_path__ + "static/media/Skirmisher's Scepter.4c97e059.jpg";